import {
  ADD_BANNER_START,
  ADD_BANNER_SUCCESS,
  ADD_BANNER_ERROR,
  UPDATE_BANNER_START,
  UPDATE_BANNER_SUCCESS,
  UPDATE_BANNER_ERROR,
  DELETE_BANNER_START,
  DELETE_BANNER_SUCCESS,
  DELETE_BANNER_ERROR,
  GET_BANNERS_START,
  GET_BANNERS_SUCCESS,
  GET_BANNERS_ERROR
} from '../../../constants';

import gql from 'graphql-tag';
import { toastr } from 'react-redux-toastr';
import { setLoaderStart, setLoaderComplete } from '../../loader/loader';

const ADD_BANNER_MUTATION = gql`
mutation(
  $tittle: String!,
  $description: String,
  $imageUrl: String!,
  $intent: String,
  $status: String!,
  $placementId: Int!,
  $startDate: String!,
  $endDate: String,
  $priority: Int,
  $isAd: Boolean!,
  $shopId: String,
  $locationIds: [Int],
  $translations: [BannerTranslationInputType]
) {
  createBanner: upsertAdminBanner(
    tittle: $tittle,
    description: $description,
    imageUrl: $imageUrl,
    intent: $intent,
    status: $status,
    placementId: $placementId,
    startDate: $startDate,
    endDate: $endDate,
    priority: $priority,
    isAd: $isAd,
    shopId: $shopId,
    locationIds: $locationIds,
    translations: $translations
  ) {
    status
    errorMessage
    result { id tittle }
  }
}`;

const UPDATE_BANNER_MUTATION = gql`
mutation(
  $id: Int!,
  $tittle: String!,
  $description: String,
  $imageUrl: String!,
  $intent: String,
  $status: String!,
  $placementId: Int!,
  $startDate: String!,
  $endDate: String,
  $priority: Int,
  $isAd: Boolean!,
  $shopId: String,
  $locationIds: [Int],
  $translations: [BannerTranslationInputType]
) {
  updateBanner: upsertAdminBanner(
    id: $id,
    tittle: $tittle,
    description: $description,
    imageUrl: $imageUrl,
    intent: $intent,
    status: $status,
    placementId: $placementId,
    startDate: $startDate,
    endDate: $endDate,
    priority: $priority,
    isAd: $isAd,
    shopId: $shopId,
    locationIds: $locationIds,
    translations: $translations
  ) {
    status
    errorMessage
    result { id tittle }
  }
}`;

const DELETE_BANNER_MUTATION = gql`
mutation($id: Int!) {
  deleteBanner: deleteAdminBanner(id: $id) {
    status
    errorMessage
  }
}`;

const GET_BANNERS_QUERY = gql`
query banners($status: String, $placementId: Int, $currentPage: Int, $search: String) {
  banners: getAdminBanners(status: $status, placementId: $placementId, currentPage: $currentPage, search: $search) {
    results {
      id
      tittle
      description
      imageUrl
      intent
      status
      placementId
      startDate
      endDate
      priority
      createdAt
      updatedAt
      isAd
      placement {
        id
        name
        label
      }
      ad {
        id
        bannerId
        shopId
        shopName
        impressionCount
        clickCount
        orderCount
      }
      locations {
        id
        locationName
      }
      translations {
        language
        tittle
        description
        imageUrl
      }
    }
    count
    status
    errorMessage
  }
}`;

const GET_ADMIN_BANNER_SHOPS_QUERY = gql`
query getAdminBannerShops($search: String) {
  getAdminBannerShops(search: $search) {
    status
    errorMessage
    results {
      id
      shopName
      email
    }
  }
}`;

const TOGGLE_BANNER_AD_MUTATION = gql`
mutation($bannerId: Int!, $isAd: Boolean!, $shopId: String) {
  toggleAdminBannerAd(bannerId: $bannerId, isAd: $isAd, shopId: $shopId) {
    status
    errorMessage
  }
}`;

export function addBanner(values) {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: ADD_BANNER_START });
    dispatch(setLoaderStart('AddBanner'));
    try {
      const { data } = await client.mutate({
        mutation: ADD_BANNER_MUTATION,
        variables: {
          ...values,
          isAd: !!values.isAd,
          shopId: values.shopId || null
        }
      });
      if (data && data.createBanner && data.createBanner.status === 200) {
        toastr.success('Success', 'Banner has been added successfully.');
        dispatch({ type: ADD_BANNER_SUCCESS });
      } else {
        toastr.error('Error', data.createBanner.errorMessage || 'Failed to add banner.');
        dispatch({ type: ADD_BANNER_ERROR });
      }
    } catch (err) {
      toastr.error('Error', err.message || 'Something went wrong!');
      dispatch({ type: ADD_BANNER_ERROR });
    }
    dispatch(setLoaderComplete('AddBanner'));
  };
}

export function updateBanner(values) {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: UPDATE_BANNER_START });
    dispatch(setLoaderStart('UpdateBanner'));
    try {
      const { data } = await client.mutate({
        mutation: UPDATE_BANNER_MUTATION,
        variables: {
          ...values,
          isAd: !!values.isAd,
          shopId: values.shopId || null
        }
      });
      if (data && data.updateBanner && data.updateBanner.status === 200) {
        toastr.success('Success', 'Banner has been updated successfully.');
        dispatch({ type: UPDATE_BANNER_SUCCESS });
      } else {
        toastr.error('Error', data.updateBanner.errorMessage || 'Failed to update banner.');
        dispatch({ type: UPDATE_BANNER_ERROR });
      }
    } catch (err) {
      toastr.error('Error', err.message || 'Something went wrong!');
      dispatch({ type: UPDATE_BANNER_ERROR });
    }
    dispatch(setLoaderComplete('UpdateBanner'));
  };
}

export function deleteBanner(id) {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: DELETE_BANNER_START });
    dispatch(setLoaderStart('DeleteBanner'));
    try {
      const { data } = await client.mutate({
        mutation: DELETE_BANNER_MUTATION,
        variables: { id }
      });
      if (data && data.deleteBanner && data.deleteBanner.status === 200) {
        toastr.success('Success', 'Banner has been deleted successfully.');
        dispatch({ type: DELETE_BANNER_SUCCESS });
      } else {
        toastr.error('Error', data.deleteBanner.errorMessage || 'Failed to delete banner.');
        dispatch({ type: DELETE_BANNER_ERROR });
      }
    } catch (err) {
      toastr.error('Error', err.message || 'Something went wrong!');
      dispatch({ type: DELETE_BANNER_ERROR });
    }
    dispatch(setLoaderComplete('DeleteBanner'));
  };
}

export function getBanners(params) {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: GET_BANNERS_START });
    try {
      const variables = { ...params };
      if (variables.tittle) {
        variables.search = variables.tittle;
        delete variables.tittle;
      }
      const { data } = await client.query({
        query: GET_BANNERS_QUERY,
        variables,
        fetchPolicy: 'network-only' // Disable cache to ensure fresh results
      });
      if (data && data.banners && data.banners.status === 200) {
        dispatch({
          type: GET_BANNERS_SUCCESS,
          payload: {
            items: data.banners.results,
            count: data.banners.count
          }
        });
      } else {
        toastr.error('Error', data.banners.errorMessage || 'Failed to fetch banners.');
        dispatch({ type: GET_BANNERS_ERROR });
      }
    } catch (err) {
      toastr.error('Error', err.message || 'Something went wrong!');
      dispatch({ type: GET_BANNERS_ERROR });
    }
  };
}

export function getAdminBannerShops(search) {
  return async (dispatch, getState, { client }) => {
    try {
      const { data } = await client.query({
        query: GET_ADMIN_BANNER_SHOPS_QUERY,
        variables: { search },
        fetchPolicy: 'network-only'
      });
      if (data && data.getAdminBannerShops && data.getAdminBannerShops.status === 200) {
        return data.getAdminBannerShops.results;
      }
      return [];
    } catch (err) {
      console.error('Error fetching shops:', err);
      return [];
    }
  };
}

const GET_LOCATIONS_QUERY = gql`
query {
  getLocations {
    id
    locationName
    isActive
  }
}`;

export function getAdminLocations() {
  return async (dispatch, getState, { client }) => {
    try {
      const { data } = await client.query({
        query: GET_LOCATIONS_QUERY,
        fetchPolicy: 'network-only'
      });
      return data && data.getLocations ? data.getLocations : [];
    } catch (err) {
      console.error('Error fetching locations:', err);
      return [];
    }
  };
}

export function toggleAdminBannerAdAction(bannerId, isAd, shopId) {
  return async (dispatch, getState, { client }) => {
    try {
      const { data } = await client.mutate({
        mutation: TOGGLE_BANNER_AD_MUTATION,
        variables: { bannerId, isAd, shopId }
      });
      if (data && data.toggleAdminBannerAd && data.toggleAdminBannerAd.status === 200) {
        toastr.success('Success', 'Ad status updated successfully.');
        return true;
      } else {
        toastr.error('Error', data.toggleAdminBannerAd.errorMessage || 'Failed to update ad status.');
        return false;
      }
    } catch (err) {
      toastr.error('Error', err.message || 'Something went wrong!');
      return false;
    }
  };
}

export default getBanners;